import { type QueryStatus } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useMy } from '@/hooks/useMy';

export interface EvmScoreData {
  evm: number;
  dvs: number;
  pas: number;
  dvsRawValue: number;
  dvsDecayedValue: number;
  dvsProgress: number;
  pasIntegrations: number;
  pasLogin: number;
  pasSeedProcessing: number;
  pasRiskTriage: number;
  engagementDays: number;
  elapsedDays: number;
  integrationCount: number;
}

export function useCustomerEvmScores() {
  const query = useMy(
    {
      resource: 'statistic',
      query: 'evm#score#now',
      allTenants: true,
    },
    {
      doNotImpersonate: true,
    }
  );

  const dataMap = useMemo(() => {
    const map = new Map<string, EvmScoreData>();

    for (const item of query.data ?? []) {
      const values = item.data?.values ?? {};
      const counts = item.data?.counts ?? {};

      map.set(item.username, {
        evm: values.evm ?? 0,
        dvs: values.dvs ?? 0,
        pas: values.pas ?? 0,
        dvsRawValue: values.dvs_raw_value ?? 0,
        dvsDecayedValue: values.dvs_decayed_value ?? 0,
        dvsProgress: values.dvs_progress ?? 0,
        pasIntegrations: values.pas_integrations ?? 0,
        pasLogin: values.pas_login ?? 0,
        pasSeedProcessing: values.pas_seed_processing ?? 0,
        pasRiskTriage: values.pas_risk_triage ?? 0,
        engagementDays: counts.engagement_days ?? 0,
        elapsedDays: counts.elapsed_days ?? 0,
        integrationCount: counts.integration_count ?? 0,
      });
    }

    return map;
  }, [query.data]);

  const status: QueryStatus = query.status;

  return {
    ...query,
    status,
    dataMap,
  };
}
